export const CONTACT = {
  phone: "484-577-3677",
  phoneHref: "tel:+14845773677",
  smsHref: "sms:+14845773677",
  email: "support@linklitepro.com",
  emailHref: "mailto:support@linklitepro.com",
  website: "LinkLitePro.com",
  area: "Serving Eastern Pennsylvania",
  hours: "Available 24/7 · Since 2008",
};

export const SERVICES = [
  {
    id: "computers",
    title: "Computers & Laptops",
    blurb: "Slow PC? Virus issues? Failing drive? We diagnose, clean and rebuild so you're back online fast.",
    image: "https://images.pexels.com/photos/7639355/pexels-photo-7639355.jpeg",
  },
  {
    id: "web",
    title: "Websites, Hosting & Savings",
    blurb: "Custom sites and rebuilds, fast secure hosting, and full website security scans — modernized to load faster and cut your monthly costs.",
    image: "https://images.unsplash.com/photo-1687603917313-ccae1a289a9d",
  },
  {
    id: "compliance",
    title: "Compliance & HIPAA Security",
    blurb: "Security scanning, monitoring and compliance support for small, medium and large businesses — including HIPAA-ready websites and IT for medical, dental and physician practices.",
    image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef",
  },
  {
    id: "network",
    title: "Network, VOIP & Cabling",
    blurb: "Routers, switches, VOIP phone systems, patch panels and structured cabling — installed and maintained by pros.",
    image: "https://images.unsplash.com/photo-1695668548342-c0c1ad479aee",
  },
  {
    id: "wifi",
    title: "Wi-Fi & Internet",
    blurb: "Dead zones and endless buffering — solved. We optimize signal and coverage across your whole space.",
    image: "https://images.unsplash.com/photo-1691435828932-911a7801adfb",
  },
  {
    id: "cctv",
    title: "CCTV Security Systems",
    blurb: "Professional camera installs that let you monitor your home or business from anywhere.",
    image: "https://images.unsplash.com/photo-1496368077930-c1e31b4e5b44",
  },
  {
    id: "doorbell",
    title: "Video Doorbells",
    blurb: "Know exactly who's at your door — even when you're not home. Clean, reliable installs.",
    image: "https://images.unsplash.com/photo-1646753002835-74296cb27a83",
  },
  {
    id: "mobile",
    title: "Smartphones & Tablets",
    blurb: "Setup, syncing and troubleshooting made simple for every device in the house.",
    image: "https://images.pexels.com/photos/3946006/pexels-photo-3946006.jpeg",
  },
  {
    id: "cloud",
    title: "Cloud & Hosting",
    blurb: "Website hosting, backups and cloud setup — fast, secure and monitored so your data is always available.",
    image: "https://images.unsplash.com/photo-1683322499436-f4383dd59f5a",
  },
  {
    id: "remote",
    title: "Remote & Onsite Support",
    blurb: "Quick remote fixes or a friendly tech at your door — whichever gets you back up and running fastest.",
    image: "https://images.unsplash.com/photo-1724260793422-7754e5d06fbe",
  },
];

export const PLATFORMS = [
  {
    id: "ucengineerpro",
    heading: "Troubleshoot & Migrate Cisco UC — One AI-Powered Workspace",
    audience: "Cisco / UC Engineers",
    desc: "Troubleshoot. Configure. Migrate. Validate. The AI-powered workspace for UC engineers — diagnose CUCM, SIP, CUBE and call-quality issues AND run CUCM 15 and Webex migrations, covering the Layer 2/3 network and troubleshooting around every cutover.",
    cta: "Launch UC Engineer Pro",
    url: "https://ucengineerpro.linklitepro.com",
    color: "#1D4ED8",
    contactEmail: "support@linklitepro.com",
    logo: "https://static.prod-images.emergentagent.com/jobs/a1a7634c-b130-494e-b3d2-443b03aeb7da/images/fa5cee5bf44089be95a3ea6d92da5666de6b0cf9d417560a0b54459465d4a620.jpeg",
  },
  {
    id: "linkwebsitepro",
    heading: "Plain-English Website SEO Audits",
    audience: "Web Developers & DIY Site Owners",
    desc: "Stop guessing on SEO or drowning in technical jargon. LINK Website Pro scans your site and tells you exactly how to boost your traffic and security compliance using simple, everyday language. Perfect for fixing your own site or giving clear reports to clients.",
    cta: "Launch Website Pro",
    url: "https://linkwebsitepro.linklitepro.com",
    color: "#A855F7",
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_lite-command-center/artifacts/dnsn7oev_IMG_9348.png",
  },
  {
    id: "linkride",
    heading: "Your Turnkey Rideshare Franchise",
    audience: "Entrepreneurs & Fleet Operators",
    desc: "Own a localized Uber or DoorDash competitor overnight. This fully white-label platform lets you upload your own logo, set your own driver rates, configure your program fees, and launch a complete dispatch business with zero tech overhead.",
    cta: "License the Franchise",
    url: "https://link.linklitepro.com",
    color: "#3B82F6",
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_lite-command-center/artifacts/wpx1yz5v_IMG_9702.png",
  },
  {
    id: "budlink",
    heading: "Premium Dispensary Menu Software",
    audience: "Legal Dispensary Operators",
    desc: "Most dispensary websites use slow, clunky, terrible menus that lose customers. Bud LINK replaces outdated systems with a beautiful, fast interface that syncs live legal strains and pricing directly into your website to keep shoppers buying from you.",
    cta: "Upgrade Your Menu",
    url: "https://budlink.linklitepro.com",
    color: "#22C55E",
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_lite-command-center/artifacts/fd7u7i2i_IMG_9110.png",
  },
  {
    id: "nationwatch",
    heading: "A Citizens' Public-Safety Network",
    audience: "USA Patriots",
    desc: "For the citizens still paying attention. Verified neighbors, moderated rooms, and public-safety awareness at the national, state, county and city level — so you hear it from your community before a cable network. Truthful, lawful, non-partisan. No extremism, no hate. Just the country watching out for itself.",
    cta: "Sign Up Now",
    url: "https://nationwatch.linklitepro.com",
    color: "#DC2626",
    soon: true,
    launch: "Launching Early 2027",
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_lite-command-center/artifacts/lkjs5fpi_13383747-7855-4F2E-8716-3A5E68F3B209.png",
  },
];

export const APPS = [
  {
    id: "link",
    name: "Link",
    tag: "Rides & Delivery",
    desc: "Locally-owned rideshare and same-day delivery in Reading, PA. No hidden fees, no tipping required.",
    url: "https://link.linklitepro.com",
    color: "#3B82F6",
  },
  {
    id: "budlink",
    name: "BudLink",
    tag: "Dispensary Search",
    desc: "One search across every legal PA dispensary. Compare strains, prices and live stock in one place. 21+.",
    url: "https://budlink.linklitepro.com",
    color: "#22C55E",
  },
  {
    id: "linkwebsitepro",
    name: "LinkWebsitePro",
    tag: "Website Intelligence",
    desc: "Scan, secure and optimize any website. Tech stack, security, SEO, compliance checks and an AI build brief in seconds.",
    url: "https://linkwebsitepro.linklitepro.com",
    color: "#A855F7",
  },
  {
    id: "linkfinance",
    name: "Link-Lite Finance",
    tag: "Personal Finance",
    desc: "All your money in one place — banks, cards, loans and Buy Now Pay Later. Live balances, bills, spending insights and cash-flow forecasting.",
    color: "#16A34A",
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_lite-command-center/artifacts/vaxa2dms_1CCCD809-BF7B-4F7D-926B-2DC46DC77356.png",
    soon: true,
  },
];

export const PLANS = [
  {
    id: "monthly",
    name: "Residential Tech Assistance",
    price: "$19.99",
    unit: "/month",
    desc: "Ongoing priority support for your home tech — remote help whenever you need it.",
    cta: "Subscribe",
    url: "https://buy.stripe.com/eVq3cw1pW76z7Eeew00gw0d",
    featured: true,
  },
  {
    id: "gethelp",
    name: "Get Help Now!",
    price: "$9.99",
    unit: "one-time",
    desc: "A fast, one-time remote support session to get you unstuck.",
    cta: "Book Now",
    url: "https://book.stripe.com/7sY6oIb0w1Mf9Mm4Vq0gw0a",
  },
  {
    id: "onsite2",
    name: "Onsite Visit · 2 Hours",
    price: "$129.99",
    unit: "up to 2 hrs",
    desc: "A tech at your door for up to 2 hours — setup, repairs or installs.",
    cta: "Book Visit",
    url: "https://book.stripe.com/8x25kE9Ws4Yr4s29bG0gw05",
  },
  {
    id: "onsite4",
    name: "Onsite Visit · 4 Hours",
    price: "$199.99",
    unit: "up to 4 hrs",
    desc: "An extended onsite visit for bigger jobs and full buildouts.",
    cta: "Book Visit",
    url: "https://book.stripe.com/cNi5kE8So9eH5w6cnS0gw06",
  },
];

export const CHAPTERS = [
  {
    num: "01",
    title: "We show up.",
    body: "Friendly, on-time and local. Trusted by homeowners and small businesses across Eastern Pennsylvania since 2008.",
  },
  {
    num: "02",
    title: "We diagnose it right.",
    body: "No guesswork and no upsell. We find the actual problem — whether it's a dying drive, a weak signal or a tangled network — and explain it in plain English.",
  },
  {
    num: "03",
    title: "We make it work.",
    body: "From a single laptop to a full CCTV and network buildout, we fix it, install it and make sure it keeps running long after we leave.",
  },
  {
    num: "04",
    title: "We build the future.",
    body: "Now we build software too — the apps and websites powering Link-Lite Data. Keeping your business and home connected.",
  },
];
